<template>
	<div class="OfferEdit quotation-sheet" :class="{ 'is-mobile': isMobile }">
		<common-body aside="4">
			<div slot="commonMain" class="quotation_box" v-loading='loading'>
				<el-row type="flex" align="middle" justify="space-between" class="quotation_header">
					<el-row type="flex" align="middle" class="location_box">
						<div class="location_icon">
							<i class="el-icon-s-promotion"></i>
						</div>
						<el-row type="flex" align="middle" class="location_text">
							<div>当前位置：</div>
							<el-button @click="goBack" type="text">我的报价</el-button>
							<div class="location_xie">/</div>
							<div>编辑单据</div>
						</el-row>
					</el-row>
				</el-row>
				<el-form :rules="rules" ref='offerEditForm' label-position="right" :model="offerEditForm" class="quotation_form">
					<el-row type="flex" align="middle" justify="space-between" class="quotation_title">
						<div class="title_leading">
							<div class="title_text">客户信息</div>
							<div v-if="!hasCustomerInfo" class="title_edit" @click="openCustomerInfoDialog">添加客户</div>
						</div>
						<div class="title_actions">
							<div class="title_toggle" @click="toggleCustomerInfo">
								<i :class="customerInfoCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
								<span>{{ customerInfoCollapsed ? '展开' : '折叠' }}</span>
							</div>
						</div>
					</el-row>
					<div v-show="!customerInfoCollapsed && hasCustomerInfo" class="quotation_info quotation_info--view">
						<div class="title_edit title_edit--info" @click="openCustomerInfoDialog">编辑</div>
						<el-row :gutter="24" class="quotation_info_row">
							<el-col :span="8">
								<div class="info-view-item">
									<div class="info-view-label">报价编号</div>
									<div class="info-view-value info-view-value--num">{{ displayText(offerEditForm.order_number) }}</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item info-view-item--customer">
									<div class="info-view-label">客户名称</div>
									<div class="info-view-value info-view-value--customer">
										<span class="info-view-customer-name">{{ displayText(customerNameText) }}</span>
										<span v-if="customerDiscountRate != 1" class="info-view-discount">
											<span class="info-view-discount-label">折扣率</span>
											<span class="info-view-discount-value info-view-value--num">{{ customerDiscountRate }}</span>
										</span>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item">
									<div class="info-view-label">报价日期</div>
									<div class="info-view-value info-view-value--num">{{ displayText(offerEditForm.createTime) }}</div>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="24" class="quotation_info_row quotation_info_row--bottom">
							<el-col :span="8">
								<div class="info-view-item info-view-item--address">
									<div class="info-view-label">收货地址</div>
									<div class="info-view-value info-view-value--multiline">{{ displayText(offerEditForm.receiving_address) }}</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item">
									<div class="info-view-label">联系人</div>
									<div class="info-view-value">{{ displayText(offerEditForm.contacts) }}</div>
								</div>
								<div class="info-view-item">
									<div class="info-view-label">联系电话</div>
									<div class="info-view-value info-view-value--num">{{ displayText(offerEditForm.contacts_phone) }}</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="info-view-item info-view-item--select">
									<div class="info-view-label">货物运输</div>
									<el-form-item prop="delivery" class="info-view-form-item">
										<el-select class="info-view-select field-full" size="mini" v-model="offerEditForm.delivery" placeholder="请选择">
											<el-option v-for="item in delivery" :key="item.id" :label="item.name" :value="Number(item.id)"></el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="info-view-item info-view-item--select">
									<div class="info-view-label">发票类型</div>
									<el-form-item prop="invoice" class="info-view-form-item">
										<el-select class="info-view-select field-full" size="mini" v-model="offerEditForm.invoice" placeholder="请选择">
											<el-option v-for="item in invoice" :key="item.id" :label="item.name" :value="Number(item.id)"></el-option>
										</el-select>
									</el-form-item>
								</div>
							</el-col>
						</el-row>
					</div>
					<el-row type="flex" align="middle" justify="space-between" class="quotation_title quotation_list_title">
						<div class="title_text">报价清单如下：</div>
						<div class="title_actions">
							<div
								class="title_stats"
								:class="{ 'is-active': goodsStatsVisible }"
								@click="goodsStatsVisible = !goodsStatsVisible"
							>{{ goodsStatsVisible ? '隐藏统计' : '统计' }}</div>
							<div @click="showGood" class="title_add">添加产品</div>
							<div @click="addExtraFeeRow" class="title_add title_add--secondary">添加费用项</div>
						</div>
					</el-row>
					<div class="quotation_list_block">
					<el-table :row-class-name="tableRowClassName" ref='offerEditTable' class="detailTable" stripe @row-dblclick="onTableRowDblClick" :border="border" :data="offerEditTableRows" style="width: 100%"
					 cell-class-name="good_text" header-cell-class-name="good_header">
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="3%" label="序号" class-name="is-num">
							<template slot-scope="scope">
								<div>{{scope.$index+1}}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%" label="名称">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<el-select
										class="extra-fee-inline-select"
										popper-class="extra-fee-select-dropdown"
										size="small"
										v-model="extraFeeLines[scope.row._extraIndex].extra_item_id"
										placeholder="请选择费用项"
										filterable
										@change="onExtraItemChange(scope.row._extraIndex)">
										<el-option v-for="opt in extraItemOptions" :key="opt.id" :label="opt.name" :value="opt.id" />
									</el-select>
								</template>
								<el-popover v-else placement="top" trigger="hover" popper-class="quotation-good-popover">
									<div class="good_reference">
										<img :src="scope.row.sku_image_text" />
									</div>
								    <div slot="reference" class="good_name">{{ cartDisplayName(scope.row) }}</div>
								  </el-popover>
							</template>
						</el-table-column>
						<el-table-column v-if="offerEditForm.category!=13&&offerEditForm.category!=19&&offerEditForm.category!=29&&offerEditForm.category!=30&&offerEditForm.category!=31&&offerEditForm.category!=40&&offerEditForm.category!=43&&offerEditForm.category!=45" :key="Math.random()" :resizable="resizeable" align="center" min-width="10%" label="尺寸(mm)" class-name="is-size">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
									<div v-else :class="{'cart-cell-pending': isCartSizePending(scope.row)}">{{ displayCartSize(scope.row) }}</div>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="14%" label="规格参数">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
									<span v-else>{{ scope.row.parameter_text }}</span>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column v-if="offerEditForm.category==20||offerEditForm.category==25||offerEditForm.category==26||offerEditForm.category==27||offerEditForm.category==28||offerEditForm.category==32||offerEditForm.category==33||offerEditForm.category==44" :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="面积(㎡)" class-name="is-num">
							<template slot-scope="scope">
								<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
								<div v-else>{{ scope.row.goods_areas }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="数量" class-name="is-num is-qty">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<input
										v-if="editingExtraQtyIndex === scope.row._extraIndex"
										:ref="'extraQtyInput_' + scope.row._extraIndex"
										class="extra-fee-qty-input"
										type="text"
										inputmode="numeric"
										:value="extraFeeLines[scope.row._extraIndex].qty"
										@input="onExtraQtyInput(scope.row._extraIndex, $event.target.value)"
										@blur="finishExtraQtyEdit(scope.row._extraIndex)"
										@keyup.enter.native="finishExtraQtyEdit(scope.row._extraIndex)" />
									<div
										v-else
										class="extra-fee-qty-display"
										title="点击修改数量"
										@click="startExtraQtyEdit(scope.row._extraIndex)">{{ extraFeeQty(extraFeeLines[scope.row._extraIndex]) }}</div>
								</template>
								<div v-else :class="{'cart-cell-pending': isCartNumPending(scope.row)}">{{ displayCartNum(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="单位">
							<template slot-scope="scope">
								<span v-if="isExtraTableRow(scope.row)" class="extra-cell-unit">{{ scope.row.goods_unit }}</span>
								<span v-else>{{ scope.row.goods_unit }}</span>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="单价" class-name="is-amount">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<input
										v-if="editingExtraUnitIndex === scope.row._extraIndex"
										:ref="'extraUnitInput_' + scope.row._extraIndex"
										class="amount extra-fee-amount-input"
										type="text"
										inputmode="decimal"
										:value="extraFeeLines[scope.row._extraIndex].unit_price"
										@input="onExtraUnitInput(scope.row._extraIndex, $event.target.value)"
										@blur="finishExtraUnitEdit(scope.row._extraIndex)"
										@keyup.enter.native="finishExtraUnitEdit(scope.row._extraIndex)" />
									<div
										v-else
										class="amount extra-fee-amount-display"
										title="点击修改单价"
										@click="startExtraUnitEdit(scope.row._extraIndex)">{{ formatExtraUnitDisplay(scope.row._extraIndex) }}</div>
								</template>
								<div v-else class="amount">{{ formatMoney(scope.row.singleton) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="折扣价" class-name="is-discount">
							<template slot-scope="scope">
								<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
								<div
									v-else
									class="amount"
									:class="{ 'amount--discount': !isDiscountSameAsSingleton(scope.row) }"
								>{{ formatDiscountPriceCell(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%" label="金额" class-name="is-amount">
							<template slot-scope="scope">
								<template v-if="isExtraTableRow(scope.row)">
									<div class="amount extra-cell-amount">{{ formatExtraAmountDisplay(scope.row._extraIndex) }}</div>
								</template>
								<div
									v-else
									class="amount"
									:class="{ 'amount--exclusive': isExclusivePriceRow(scope.row) }"
								>{{ formatAmountCell(scope.row) }}</div>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%" label="备注">
							<template slot-scope="scope">
								<el-row type="flex" align="middle" justify="center" class="good_size">
									<el-input
										v-if="isExtraTableRow(scope.row)"
										class="extra-fee-inline-remark"
										size="small"
										v-model="extraFeeLines[scope.row._extraIndex].remark"
										placeholder="选填"
										maxlength="200"
										@input="touchExtraFeeLines" />
									<div v-else>{{ scope.row.remarks || '' }}</div>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column :key="Math.random()" :resizable="resizeable" align="center" width="196" label="操作" class-name="quotation-action-col">
							<template slot-scope="scope">
								<div class="lq-row-actions">
									<template v-if="!isExtraTableRow(scope.row)">
									<el-tooltip content="编辑" placement="top">
										<el-button type="text" icon="el-icon-edit" class="lq-row-action-btn" @click.stop="editCart(scope.row)" />
									</el-tooltip>
									<el-tooltip content="克隆" placement="top">
										<el-button type="text" icon="el-icon-document-copy" class="lq-row-action-btn" @click.stop="cloneCart(scope.row._cartIndex)" />
									</el-tooltip>
									<el-tooltip content="上移" placement="top">
										<el-button type="text" icon="el-icon-top" class="lq-row-action-btn" @click.stop="upLayer(scope.row._cartIndex, scope.row)" />
									</el-tooltip>
									<el-tooltip content="下移" placement="top">
										<el-button type="text" icon="el-icon-bottom" class="lq-row-action-btn" @click.stop="downLayer(scope.row._cartIndex, scope.row)" />
									</el-tooltip>
									</template>
									<el-popconfirm @confirm="delTableRow(scope.row)" confirmButtonType="danger" confirmButtonText="删除" :title="isExtraTableRow(scope.row) ? '确定删除该费用项吗？' : '确定删除该产品吗？'">
										<el-tooltip content="删除" placement="top" slot="reference">
											<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" @click.stop />
										</el-tooltip>
									</el-popconfirm>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="goods_footer">
						<el-row type="flex" align="middle" class="goods_footer_item goods_footer_item--amount">
							<div class="goods_footer_amount_block">
								<el-row type="flex" align="middle" class="goods_footer_amount_line">
									<div class="goods_footer_text goods_footer_text--strong">小计：<span class="amount">¥</span></div>
									<el-form-item :show-message="showMsg" prop="totalAll" class="goods_footer_money_item">
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											placeholder="请输入"
											v-model="offerEditForm.totalAll"
											@blur="formatFooterAmount('totalAll')"
										></el-input>
									</el-form-item>
								</el-row>
							</div>
							<div
								class="goods_footer_amount_spacer"
								aria-hidden="true"
								:style="{ flex: '0 0 ' + footerAmountSpacerPx + 'px', width: footerAmountSpacerPx + 'px', maxWidth: footerAmountSpacerPx + 'px' }"
							></div>
						</el-row>
						<el-row type="flex" align="middle" class="goods_footer_item goods_footer_item--amount">
							<div class="goods_footer_text goods_footer_maker">制单人：{{userName || userInfo.nickname}}</div>
							<div class="goods_footer_amount_block goods_footer_amount_block--inline">
								<el-row type="flex" align="middle" class="goods_footer_amount_line goods_footer_amount_line--pair">
									<div class="goods_footer_text goods_footer_text--strong">折扣让利：<span class="amount">-¥</span></div>
									<el-form-item :show-message="showMsg" prop="concession" class="goods_footer_money_item">
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											placeholder="0.00"
											:value="concessionAbsText"
										></el-input>
									</el-form-item>
									<div class="goods_footer_text goods_footer_text--strong goods_footer_text--pair-gap">合计：<span class="amount">¥</span></div>
									<el-form-item :show-message="showMsg" prop="total" class="goods_footer_money_item">
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											placeholder="请输入"
											v-model="offerEditForm.total"
											@blur="formatFooterAmount('total')"
										></el-input>
									</el-form-item>
								</el-row>
							</div>
							<div
								class="goods_footer_amount_spacer"
								aria-hidden="true"
								:style="{ flex: '0 0 ' + footerAmountSpacerPx + 'px', width: footerAmountSpacerPx + 'px', maxWidth: footerAmountSpacerPx + 'px' }"
							></div>
						</el-row>
						<el-row type="flex" align="top" class="goods_footer_item goods_footer_item--remark">
							<div class="goods_footer_text goods_footer_text--remark">订单备注：</div>
							<el-form-item prop="remarks" class="goods_footer_remark_item">
								<el-input
									type="textarea"
									:autosize="{ minRows: 2, maxRows: 5 }"
									:clearable="clearable"
									resize="none"
									class="goods_footer_remark"
									placeholder="请输入订单备注"
									v-model="offerEditForm.remarks" />
							</el-form-item>
						</el-row>
					</div>
					</div>
					<el-form-item>
						<div class="quotation_btn" @click="submitForm('offerEditForm')">确认单据</div>
					</el-form-item>
				</el-form>
				<!-- 客户信息编辑 -->
				<customer-info-dialog
					ref="customerInfoDialog"
					:visible.sync="customerInfoStatus"
					:title="customerInfoDialogTitle"
					:draft="customerInfoDraft"
					:rules="customerRules"
					:readonly="readonly"
					:clearable="clearable"
					:editable="editable"
					:customer-select-options="customerSelectOptions"
					customer-placeholder="请选择"
					dialog-width="920px"
					:filter-method="filterCustomerOptions"
					@select-visible="onCustomerSelectVisible"
					@customer-change="onDraftCustomerChange"
					@close="cancelCustomerInfo"
					@cancel="cancelCustomerInfo"
					@confirm="confirmCustomerInfo" />
				<!-- 选择产品 -->
				<good-picker-dialog
					:visible.sync="goodStatus"
					:is-mobile="isMobile"
					:search.sync="search"
					:types="types"
					:type-index.sync="typeIndex"
					:good-list="goodList"
					:resizeable="resizeable"
					name-min-width="40%"
					summary-min-width="48%"
					:name-tooltip="true"
					@search="searchGood"
					@change-type="changeType"
					@close="closeGoodDialog"
					@choose="chooseGood"
					@row-click="onGoodRowClick"
					@current-change="selectGood" />
				<!-- 产品详情 -->
				<cart-detail-dialog
					ref="cartDetailDialog"
					:visible.sync="cartStatus"
					:is-mobile="isMobile"
					:good="good"
					:cart-form="cartForm"
					:cart-rules="cartRules"
					:sku-active="skuActive"
					:is-editing-pending-cart="isEditingPendingCart"
					:upload-limit="uploadLimit"
					:file-type="fileType"
					:modal="!goodStatus"
					:close-on-click-modal="!isMobile"
					:show-upload="!isMobile"
					@submit="submitCart"
					@select-spec="selectSpec"
					@select-mid-param="selectMidParam"
					@select-param="selectParam"
					@price-init="priceInit"
					@auto-cal-price="autoCalPrice"
					@closed="onCartDialogClosed" />
			</div>
		</common-body>
		<GoodsStatsFloat :visible.sync="goodsStatsVisible" :stats="cartGoodsStats" />
	</div>
</template>

<script>
	import GoodsStatsFloat from "@/components/GoodsStatsFloat"
	import CustomerInfoDialog from "@/components/quotation/CustomerInfoDialog.vue"
	import GoodPickerDialog from "@/components/quotation/GoodPickerDialog.vue"
	import CartDetailDialog from "@/components/quotation/CartDetailDialog.vue"
	import {
		accMul,
		accDiv,
		accAdd,
		accSub,
		getT,
		getTimestamp
	} from "../assets/js/public.js"
	import { cartDisplayName } from '@/utils/cart-display'
	import { buildCartGoodsStats, parseCartLengthMm as parseCartLengthMmUtil } from '@/utils/cart-stats'
	import { serializeExtraFees, sumExtraFeeLines, mergeEditableTableRows, isExtraTableRow, extraFeeQty, extraFeeUnitPrice, extraFeeLineAmount, normalizeExtraFeeLine } from '@/utils/extra-fees'
	import {
		isNestedParameter as isNestedParam,
		leafOptionsForMid,
		normalizeParameterList,
		onMidParameterChange,
		onLeafParameterChange,
		flatLeafParameterChange,
		shouldShowParameterItem as isParameterItemVisible,
		collectParameterIds,
		syncSwitchParameterVisibility,
	} from '@/utils/cart-parameter'
	import { applyMobileViewport } from '@/utils/isMobile'
	import { forceHideQuotationDialogs } from '@/utils/element-overlay'
	export default {
		name: 'OfferEdit',
		components:{
			GoodsStatsFloat,
			CustomerInfoDialog,
			GoodPickerDialog,
			CartDetailDialog
		},
		data() {
			return {
				baseUrl: process.env.CDN_BASE || "http://127.0.0.1:19000/baojia-system",
				loading: !0,
				goodsStatsVisible: !1,
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				userName: '',
				customerInfoCollapsed: false,
				customerInfoStatus: !1,
				customerInfoIsEdit: !1,
				customerSelectQuery: '',
				customerInfoDraft: {
					order_number: '',
					customer_id: '',
					receiving_address: '',
					createTime: '',
					contacts: '',
					contacts_phone: '',
				},
				offerEditForm: {
					order_number: '',
					customer_id: '',
					receiving_address: '',
					createTime: '',
					contacts: '',
					contacts_phone: '',
					delivery: '',
					invoice: '',
					total: 0,
					totalAll: 0,
					total_primary: 0,
					/** 让利（成交合计 − 金额小计，通常为负或 0） */
					concession: 0,
					preferential: 0,
					remarks: '',
				},
				resizeable: !1,
				editable: !1,
				clearable: !0,
				showMsg: !1,
				readonly: !0,
				border: !0,
				rules: {
					delivery: [{
						required: true,
						message: '请选择运输方式',
						trigger: 'change'
					}],
					invoice: [{
						required: true,
						message: '请选择发票类型',
						trigger: 'change'
					}],
				},
				customerRules: {
					order_number: [{
						required: true,
						message: '报价编号不能为空',
						trigger: 'blur'
					}],
					customer_id: [{
						required: true,
						message: '请选择客户名称',
						trigger: 'change'
					}],
					receiving_address: [{
						required: true,
						message: '收货地址不能为空',
						trigger: 'blur'
					}],
					createTime: [{
						required: true,
						message: '请选择报价日期',
						trigger: 'change'
					}],
					contacts: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contacts_phone: [{
						required: true,
						message: '联系电话不能为空',
						trigger: 'blur'
					}],
				},
				page: 1,
				limit: 999,
				customer: [],
				customerIndex: '',
				delivery: [],
				invoice: [],
				goodStatus: !1,
				resumeGoodPicker: !1,
				good: null,
				goodList: [],
				cartStatus: !1,
				cartList: [],
				extraFeeLines: [],
				extraItemOptions: [],
				editingExtraAmountIndex: -1,
				editingExtraQtyIndex: -1,
				editingExtraUnitIndex: -1,
				cartForm: {
					cart_id: "",
					goods_id: "",
					sku_ids: "",
					goods_long: "",
					goods_wide: "",
					goods_high: "",
					goods_thick: "",
					reference_image: "",
					remarks: "",
					goods_num: 1,
					goods_category: "",
					order_number: "",
					goods_size: "",
					parameter_ids: ""
				},
				cartRules: {
					
				},
				fileType: ["jpg","jpeg","png","dxf","dws","dwg"],
				specIds: [],
				search: '',
				types: [],
				typeIndex: 0,
				quotationStatus: !1,
				uploadLimit: 6,
				goodActive: 0,
				skuActive: -1,
				cartSubmit: !1,
				customerDiscountRate: 1,
				customerExclusivePriceMap: {},
				customerExclusiveSkuKeyMap: {},
				footerAmountSpacerPx: 0,
				/** 清单变更后递增，驱动 goods_stats 实时重算 */
				cartStatsTick: 0,
				isMobile: false,
			}
		},
		created() {
			this.isMobile = applyMobileViewport()
			this.reload();
		},
		mounted() {
			this.isMobile = applyMobileViewport()
		},
		computed: {
			customerNameText() {
				const found = this.customer.find(item => String(item.id) === String(this.offerEditForm.customer_id))
				return found ? found.name : ''
			},
			hasCustomerInfo() {
				return !!this.offerEditForm.customer_id
			},
			customerInfoDialogTitle() {
				return this.customerInfoIsEdit ? '编辑客户' : '添加客户'
			},
			customerSelectOptions() {
				const list = Array.isArray(this.customer) ? this.customer : []
				const q = (this.customerSelectQuery || '').trim().toLowerCase()
				let options = list
				if (q) {
					options = list.filter((item) => {
						const name = String(item.name || '').toLowerCase()
						const contacts = String(item.contacts || '').toLowerCase()
						const phone = String(item.phone || '').toLowerCase()
						return name.indexOf(q) !== -1 || contacts.indexOf(q) !== -1 || phone.indexOf(q) !== -1
					})
				}
				const selectedId = this.customerInfoDraft.customer_id
				if (selectedId !== '' && selectedId !== null && selectedId !== undefined) {
					const exists = options.some((item) => String(item.id) === String(selectedId))
					if (!exists) {
						const selected = list.find((item) => String(item.id) === String(selectedId))
						if (selected) options = [selected].concat(options)
					}
				}
				return options
			},
			isEditingPendingCart() {
				const row = this.cartList[this.goodActive]
				return !!(row && row.pending_edit)
			},
			/** 让利展示绝对值（标签已带 -￥） */
			concessionAbsText() {
				const n = Math.abs(Number(this.offerEditForm.concession) || 0)
				return n.toFixed(2)
			},
			/** 清单统计：总览 + 按名称/规格分组明细（与 quotation 共用 util） */
			cartGoodsStats() {
				const that = this
				void that.cartStatsTick
				return buildCartGoodsStats(that.cartList, {
					isNumPending(row) { return that.isCartNumPending(row) },
					isSizePending(row) { return that.isCartSizePending(row) }
				})
			},
			offerEditTableRows() {
				return mergeEditableTableRows(this.cartList, this.extraFeeLines)
			},
		},
		beforeUpdate() {
			this.$nextTick(() => {
				if (this.$refs.offerEditTable) {
					this.$refs.offerEditTable.doLayout()
				}
				this.syncOfferEditAlign()
			})
		},
		methods: {
			cartDisplayName,
			isExtraTableRow,
			extraFeeQty,
			onTableRowDblClick(row) {
				if (isExtraTableRow(row)) return
				this.editCart(row)
			},
			addExtraFeeRow() {
				this.extraFeeLines.push({
					extra_item_id: '',
					name: '',
					qty: 1,
					unit_price: '',
					amount: '',
					remark: '',
				})
			},
			touchExtraFeeLines() {
				this.extraFeeLines = this.extraFeeLines.slice()
			},
			onExtraItemChange(index) {
				const row = this.extraFeeLines[index]
				if (!row) return
				const opt = (this.extraItemOptions || []).find(function(item) {
					return String(item.id) === String(row.extra_item_id)
				})
				if (opt) row.name = opt.name
				this.touchExtraFeeLines()
			},
			formatExtraAmountDisplay(index) {
				const row = this.extraFeeLines[index]
				const amount = extraFeeLineAmount(row)
				if (!(amount > 0)) return '¥ 0.00'
				return this.formatMoney(amount) || '¥ 0.00'
			},
			formatExtraUnitDisplay(index) {
				const row = this.extraFeeLines[index]
				const unit = extraFeeUnitPrice(row)
				if (!(unit > 0)) return '¥ 0.00'
				return this.formatMoney(unit) || '¥ 0.00'
			},
			focusExtraInput(refKey) {
				this.$nextTick(() => {
					const ref = this.$refs[refKey]
					const el = Array.isArray(ref) ? ref[0] : ref
					if (el && el.focus) {
						el.focus()
						el.select && el.select()
					}
				})
			},
			syncExtraFeeLine(index) {
				const row = this.extraFeeLines[index]
				if (!row) return
				const next = normalizeExtraFeeLine(row)
				if (next) this.$set(this.extraFeeLines, index, next)
				this.touchExtraFeeLines()
				this.getTotal()
			},
			startExtraQtyEdit(index) {
				this.editingExtraUnitIndex = -1
				this.editingExtraQtyIndex = index
				this.focusExtraInput('extraQtyInput_' + index)
			},
			onExtraQtyInput(index, val) {
				const row = this.extraFeeLines[index]
				if (!row) return
				let text = String(val == null ? '' : val).replace(/[^\d]/g, '')
				row.qty = text === '' ? '' : parseInt(text, 10)
				this.touchExtraFeeLines()
			},
			finishExtraQtyEdit(index) {
				const row = this.extraFeeLines[index]
				if (row) {
					const n = Number(row.qty)
					row.qty = Number.isFinite(n) && n > 0 ? n : 1
				}
				this.editingExtraQtyIndex = -1
				this.syncExtraFeeLine(index)
			},
			startExtraUnitEdit(index) {
				this.editingExtraQtyIndex = -1
				this.editingExtraUnitIndex = index
				this.focusExtraInput('extraUnitInput_' + index)
			},
			onExtraUnitInput(index, val) {
				const row = this.extraFeeLines[index]
				if (!row) return
				let text = String(val == null ? '' : val).replace(/[^\d.]/g, '')
				const parts = text.split('.')
				if (parts.length > 2) text = parts[0] + '.' + parts.slice(1).join('')
				row.unit_price = text
				this.touchExtraFeeLines()
			},
			finishExtraUnitEdit(index) {
				const row = this.extraFeeLines[index]
				if (row) {
					const n = Number(row.unit_price)
					row.unit_price = Number.isFinite(n) && n > 0 ? n.toFixed(2) : ''
				}
				this.editingExtraUnitIndex = -1
				this.syncExtraFeeLine(index)
			},
			startExtraAmountEdit(index) {
				this.startExtraUnitEdit(index)
			},
			finishExtraAmountEdit(index) {
				this.finishExtraUnitEdit(index)
			},
			onExtraAmountInput(index, val) {
				this.onExtraUnitInput(index, val)
			},
			formatExtraAmount(index) {
				this.syncExtraFeeLine(index)
			},
			delTableRow(row) {
				if (isExtraTableRow(row)) {
					this.extraFeeLines.splice(row._extraIndex, 1)
					this.getTotal()
					return
				}
				this.delGood(row._cartIndex)
			},
			syncOfferEditAlign() {
				this.syncFooterAmountAlign()
			},
			syncFooterAmountAlign() {
				const table = this.$refs.offerEditTable
				if (!table || !table.$el) return
				const tableEl = table.$el
				const headerWrapper = tableEl.querySelector('.el-table__header-wrapper') || tableEl
				const amountThs = headerWrapper.querySelectorAll('th.is-amount')
				if (!amountThs.length) return
				const amountTh = amountThs[amountThs.length - 1]
				const tableRect = headerWrapper.getBoundingClientRect()
				const amountThRect = amountTh.getBoundingClientRect()
				const spacer = Math.max(0, Math.round(tableRect.right - amountThRect.right))
				if (spacer !== this.footerAmountSpacerPx) {
					this.footerAmountSpacerPx = spacer
				}
			},
			displayText(val) {
				return val !== undefined && val !== null && val !== '' ? val : '—'
			},
			/** 字典下拉 id 统一为 number，避免字符串 id 导致 el-select 只显示数字 */
			normalizeSelectId(val) {
				if (val === undefined || val === null || val === '') return ''
				const n = Number(val)
				return Number.isFinite(n) && n > 0 ? n : ''
			},
			toggleCustomerInfo() {
				this.customerInfoCollapsed = !this.customerInfoCollapsed
			},
			customerInfoFormRef() {
				const dlg = this.$refs.customerInfoDialog
				return (dlg && typeof dlg.getForm === 'function' && dlg.getForm()) || (dlg && dlg.$refs.customerInfoForm)
			},
			customerSelectRef() {
				const dlg = this.$refs.customerInfoDialog
				return (dlg && typeof dlg.getSelect === 'function' && dlg.getSelect()) || (dlg && dlg.$refs.customerSelect)
			},
			cartFormRef() {
				const dlg = this.$refs.cartDetailDialog
				return (dlg && typeof dlg.getForm === 'function' && dlg.getForm()) || (dlg && dlg.$refs.cartForm) || this.$refs.cartForm
			},
			snapshotCustomerInfoDraft() {
				const form = this.offerEditForm
				let customerId = form.customer_id
				if (customerId !== '' && customerId != null) {
					const found = this.customer.find((item) => String(item.id) === String(customerId))
					if (found) customerId = found.id
				}
				return {
					order_number: form.order_number,
					customer_id: customerId,
					receiving_address: form.receiving_address,
					createTime: form.createTime,
					contacts: form.contacts,
					contacts_phone: form.contacts_phone,
				}
			},
			openCustomerInfoDialog() {
				let that = this
				that.customerInfoIsEdit = !!that.offerEditForm.customer_id
				that.customerSelectQuery = ''
				that._ignoreNextCustomerFilter = !0
				const applyOpen = function() {
					that.customerInfoDraft = that.snapshotCustomerInfoDraft()
					that.customerInfoStatus = !0
					that.$nextTick(function() {
						const customerForm = that.customerInfoFormRef()
						if (customerForm) customerForm.clearValidate()
					})
				}
				if (!that.customer || that.customer.length === 0) {
					that.$fetch('addons/hlm/api.Customer/getCustomerList', {
						page: that.page,
						limit: that.limit,
						search: ''
					}).then(function(res) {
						if (res.code == 1) {
							that.customer = res.data.list
							that.syncCustomerIndex()
						}
						applyOpen()
					}).catch(function() {
						applyOpen()
					})
					return
				}
				applyOpen()
			},
			filterCustomerOptions(query) {
				if (this._ignoreNextCustomerFilter) {
					this._ignoreNextCustomerFilter = !1
					this.customerSelectQuery = ''
					return
				}
				this.customerSelectQuery = query == null ? '' : String(query)
			},
			onCustomerSelectVisible(visible) {
				if (visible) {
					this._ignoreNextCustomerFilter = !0
					this.customerSelectQuery = ''
					this.$nextTick(() => {
						this.customerSelectQuery = ''
						const sel = this.customerSelectRef()
						if (sel) {
							sel.query = ''
							if (typeof sel.handleQueryChange === 'function') {
								this._ignoreNextCustomerFilter = !0
								sel.handleQueryChange('')
							}
						}
					})
					return
				}
				this.customerSelectQuery = ''
			},
			onDraftCustomerChange(id) {
				if (id === '' || id === null || id === undefined) {
					this.customerInfoDraft.customer_id = ''
					return
				}
				const item = this.customer.find((row) => String(row.id) === String(id))
				if (!item) return
				this.customerInfoDraft.customer_id = item.id
				this.customerInfoDraft.contacts = item.contacts
				this.customerInfoDraft.contacts_phone = item.phone
				this.customerInfoDraft.receiving_address = item.receiving_address
			},
			cancelCustomerInfo() {
				this.customerInfoStatus = !1
				this.customerSelectQuery = ''
			},
			confirmCustomerInfo() {
				let that = this
				const customerForm = that.customerInfoFormRef()
				if (!customerForm) return
				customerForm.validate(function(valid) {
					if (!valid) return
					const prevCustomerId = that.offerEditForm.customer_id
					const nextCustomerId = that.customerInfoDraft.customer_id
					Object.assign(that.offerEditForm, {
						order_number: that.customerInfoDraft.order_number,
						customer_id: that.customerInfoDraft.customer_id,
						receiving_address: that.customerInfoDraft.receiving_address,
						createTime: that.customerInfoDraft.createTime,
						contacts: that.customerInfoDraft.contacts,
						contacts_phone: that.customerInfoDraft.contacts_phone,
					})
					that.syncCustomerIndex()
					that.loadCustomerPricing(that.offerEditForm.customer_id)
					that.customerInfoStatus = !1
					that.customerSelectQuery = ''
					const customerChanged = String(prevCustomerId || '') !== String(nextCustomerId || '')
					// 编辑历史单：换客户时二选一（仅本单 cart）
					if (that.cartList && that.cartList.length > 0 && customerChanged) {
						that.$confirm(
							'已更换客户。可仅更新客户信息，或按新客户折扣/专属价重算本单清单价格。',
							'更换客户',
							{
								distinguishCancelAndClose: !0,
								confirmButtonText: '按新客户重算清单',
								cancelButtonText: '仅更新客户',
								type: 'warning',
								customClass: 'quotation-draft-confirm',
								closeOnClickModal: !1,
								closeOnPressEscape: !1
							}
						).then(function() {
							that.repriceOfferCart()
						}).catch(function() {
							// 仅更新客户：清单价格保持不变
						})
					}
				})
			},
			/** 按客户折扣/专属价重算当前编辑单购物车（不影响其它已确认单据） */
			repriceOfferCart() {
				let that = this
				const orderNumber = that.offerEditForm.order_number
				if (!orderNumber) return
				that.$post('addons/hlm/api.Cart/repriceCart', {
					order_number: orderNumber,
					customer_id: that.offerEditForm.customer_id || 0
				}).then(function(res) {
					if (res.code == 1) {
						that.cartList = that.filterValidCartRows(res.data)
						that.getTotal()
						that.$message({
							message: '已按新客户重算清单价格',
							type: 'success',
							duration: 2000,
							center: !0
						})
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			validateCustomerInfo(callback) {
				const form = this.offerEditForm
				const valid = !!(form.order_number && form.customer_id && form.receiving_address &&
					form.createTime && form.contacts && form.contacts_phone)
				callback(valid)
			},
			syncCustomerIndex() {
				if (this.customerIndex !== '' && this.customer[this.customerIndex] &&
					String(this.customer[this.customerIndex].id) === String(this.offerEditForm.customer_id)) {
					return
				}
				if (!this.offerEditForm.customer_id) {
					this.customerIndex = ''
					return
				}
				const idx = this.customer.findIndex(item => String(item.id) === String(this.offerEditForm.customer_id))
				this.customerIndex = idx >= 0 ? idx : ''
			},
			formatMoney(val) {
				if (val === undefined || val === null || val === '') return ''
				let text = String(val).trim()
				if (!text) return ''
				if (text.indexOf('¥') === 0 || text.indexOf('￥') === 0) text = text.slice(1).trim()
				const num = Number(text)
				if (!Number.isFinite(num)) return '¥ ' + text
				return '¥ ' + num.toFixed(2)
			},
			formatSizeText(text) {
				if (text === undefined || text === null || text === '' || text === '-') return text
				return String(text).replace(/长/g, '')
			},
			parseCartLengthMm(row) {
				const that = this
				return parseCartLengthMmUtil(row, {
					isSizePending(r) { return that.isCartSizePending(r) }
				})
			},
			resolveDiscountPrice(row) {
				if (!row) return ''
				if (row.discount_price !== undefined && row.discount_price !== null && row.discount_price !== '') {
					return row.discount_price
				}
				return row.singleton
			},
			isSamePrice(a, b) {
				const na = Number(a)
				const nb = Number(b)
				if (Number.isFinite(na) && Number.isFinite(nb)) {
					return Math.abs(na - nb) < 1e-6
				}
				const emptyA = a === undefined || a === null || a === ''
				const emptyB = b === undefined || b === null || b === ''
				if (emptyA && emptyB) return true
				return String(a) === String(b)
			},
			isDiscountSameAsSingleton(row) {
				if (!row) return true
				return this.isSamePrice(this.resolveDiscountPrice(row), row.singleton)
			},
			formatDiscountPriceCell(row) {
				if (this.isDiscountSameAsSingleton(row)) return '-'
				return this.formatMoney(this.resolveDiscountPrice(row))
			},
			/** 是否客户专属价商品行（不参与折扣让利） */
			isExclusivePriceRow(row) {
				if (!row || !row.goods_id) return false
				const skuKey = String(row.goods_id) + '__' + String(row.sku_ids || '')
				if (this.customerExclusiveSkuKeyMap && this.customerExclusiveSkuKeyMap[skuKey] != null) {
					return true
				}
				const skuField = String(row.sku_ids || '').trim()
				if (!skuField) {
					return this.customerExclusivePriceMap && this.customerExclusivePriceMap[String(row.goods_id) + '_0'] != null
				}
				return false
			},
			/** 金额列：普通行=单价×数量；专属价行=专属价×数量（紫色） */
			formatAmountCell(row) {
				if (!row || this.isCartNumPending(row)) return '-'
				const exclusive = this.isExclusivePriceRow(row)
				const unit = Number(exclusive ? this.resolveDiscountPrice(row) : row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num)) {
					return this.formatMoney(exclusive ? this.resolveDiscountPrice(row) : row.singleton)
				}
				return this.formatMoney(accMul(unit, num))
			},
			formatAmountBySingleton(row) {
				return this.formatAmountCell(row)
			},
			formatFooterAmount(field) {
				const v = this.offerEditForm[field]
				if (v === '' || v === null || v === undefined) return
				const n = Number(v)
				if (!isFinite(n)) return
				this.offerEditForm[field] = n.toFixed(2)
			},
			loadCustomerPricing(customerId) {
				const that = this
				const id = Number(customerId || 0)
				that.customerDiscountRate = 1
				that.customerExclusivePriceMap = {}
				that.customerExclusiveSkuKeyMap = {}
				if (!id) return
				const cust = (that.customer || []).find(function(row) {
					return String(row.id) === String(id)
				})
				if (cust && cust.discount_rate != null && cust.discount_rate !== '') {
					const rate = Number(cust.discount_rate)
					that.customerDiscountRate = Number.isFinite(rate) && rate > 0 ? rate : 1
				}
				that.$fetch('addons/hlm/api.Customer/getCustomerDetails', { id: id }).then(function(detailRes) {
					if (detailRes.code == 1 && detailRes.data) {
						const rate = Number(detailRes.data.discount_rate)
						if (Number.isFinite(rate) && rate > 0) that.customerDiscountRate = rate
						const idx = (that.customer || []).findIndex(function(row) {
							return String(row.id) === String(id)
						})
						if (idx >= 0) that.$set(that.customer[idx], 'discount_rate', String(that.customerDiscountRate))
					}
				}).catch(function(err) {
					console.log(err)
				})
				that.$fetch('addons/hlm/api.Customer/getGoodsPriceList', {
					customer_id: id
				}).then(function(res) {
					if (res.code != 1) return
					const map = {}
					const skuKeyMap = {}
					;(res.data || []).forEach(function(row) {
						const price = Number(row.price)
						const key = String(row.goods_id) + '_' + String(row.sku_id || 0)
						map[key] = price
						const skuKey = String(row.goods_id) + '__' + String(row.goods_sku_ids || '')
						skuKeyMap[skuKey] = price
					})
					that.customerExclusivePriceMap = map
					that.customerExclusiveSkuKeyMap = skuKeyMap
					that.getTotal()
				}).catch(function(err) {
					console.log(err)
				})
			},
			isEmptyDimValue(val) {
				if (val === undefined || val === null) return true
				const text = String(val).trim()
				return text === '' || text === '0'
			},
			isCartPendingEdit(row) {
				return !!(row && row.pending_edit)
			},
			isCartSizeInvalid(row) {
				if (!row) return false
				const v = Number(row.goods_valuation)
				if (v === 1) return false
				if (v === 2 || v === 3 || v === 8 || v === 10 || v === 11) {
					return this.isEmptyDimValue(row.goods_long)
				}
				if (v === 4 || v === 5 || v === 12 || v === 13) {
					return this.isEmptyDimValue(row.goods_long) || this.isEmptyDimValue(row.goods_wide)
				}
				if (v === 6 || v === 7) {
					return this.isEmptyDimValue(row.goods_high) || this.isEmptyDimValue(row.goods_wide)
				}
				if (v === 9) {
					return this.isEmptyDimValue(row.goods_high) || this.isEmptyDimValue(row.goods_wide) || this.isEmptyDimValue(row.goods_thick)
				}
				return false
			},
			isCartNumInvalid(row) {
				if (!row) return false
				const num = Number(row.goods_num)
				return !Number.isFinite(num) || num <= 0
			},
			isCartSizePending(row) {
				return this.isCartPendingEdit(row) && this.isCartSizeInvalid(row)
			},
			isCartNumPending(row) {
				return this.isCartPendingEdit(row) && this.isCartNumInvalid(row)
			},
			displayCartSize(row) {
				if (Number(row.goods_valuation) === 1) return '-'
				if (this.isCartSizePending(row)) return '-'
				const text = this.formatSizeText(row.size_text)
				return text || '-'
			},
			displayCartNum(row) {
				if (this.isCartNumPending(row)) return '-'
				return row.goods_num
			},
			normalizePendingCartForm() {
				const fields = ['goods_long', 'goods_wide', 'goods_high', 'goods_thick']
				fields.forEach((key) => {
					if (this.isEmptyDimValue(this.cartForm[key])) this.cartForm[key] = ''
				})
				if (this.isCartNumInvalid(this.cartForm)) this.cartForm.goods_num = undefined
			},
			isCartFormPendingInvalid() {
				const formRow = Object.assign({}, this.cartForm, { goods_valuation: this.good && this.good.valuation })
				return this.isCartSizeInvalid(formRow) || this.isCartNumInvalid(formRow)
			},
			hasPendingCloneItems() {
				return this.cartList.some((row) => this.isCartNumPending(row) || this.isCartSizePending(row))
			},
			filterValidCartRows(list) {
				const orderNumber = String(this.offerEditForm.order_number || '')
				const categoryId = Number(this.offerEditForm.category) || 0
				if (!orderNumber) return []
				return (Array.isArray(list) ? list : []).filter(function(item) {
					return item && item.id
						&& String(item.order_number || '') === orderNumber
						&& (!categoryId || Number(item.goods_category) === categoryId)
				})
			},
			syncCartList(callback) {
				let that = this
				const orderNumber = that.offerEditForm.order_number
				if (!orderNumber) {
					that.cartList = []
					if (callback) callback()
					return
				}
				that.$fetch('addons/hlm/api.Cart/getCartList', {
					order_number: orderNumber
				}).then(function(res) {
					if (res.code == 1) {
						that.cartList = that.filterValidCartRows(res.data)
					} else {
						that.cartList = []
					}
					if (callback) callback()
				}).catch(function(error) {
					console.log(error)
					that.cartList = []
					if (callback) callback()
				})
			},
			reload() {
				let that = this				
				that.offer_id = that.$route.query.id, that.getDelivery()
			},
			getDelivery(e) {
				let that = this
				that.$fetch('addons/hlm/api.Order/transportList').then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.delivery = res.data,that.getInvoice()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getInvoice(e) {
				let that = this
				that.$fetch('addons/hlm/api.Order/invoiceList').then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.invoice = res.data, that.getDetail()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			loadExtraItemOptions() {
				let that = this
				that.$fetch('addons/hlm/api.ExtraItem/options').then(function(res) {
					if (res.code == 1) {
						that.extraItemOptions = Array.isArray(res.data) ? res.data : []
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getDetail() {
				let that = this
				that.$fetch('addons/hlm/api.Order/getOderDetails', {
					id: that.offer_id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let detail = res.data
						that.userName = detail.user_name
						let offerEditForm = {
							order_number: '',
							customer_id: '',
							receiving_address: '',
							createTime: '',
							contacts: '',
							contacts_phone: '',
							delivery: '',
							invoice: '',
							totalAll: 0,
							total: 0,
							total_primary: 0,
							concession: 0,
							preferential: 0,
							remarks: '',
							goods: []
						}
						offerEditForm.customer_id = detail.customer_ids
						offerEditForm.delivery = that.normalizeSelectId(detail.delivery)
						offerEditForm.invoice = that.normalizeSelectId(detail.invoice)
						offerEditForm.id = detail.id
						offerEditForm.category = detail.category
						offerEditForm.remarks = detail.remarks
						offerEditForm.total = detail.total
						offerEditForm.preferential = detail.preferential
						offerEditForm.order_number = detail.order_number
						offerEditForm.receiving_address = detail.receiving_address
						offerEditForm.contacts = detail.contacts
						offerEditForm.contacts_phone = detail.contacts_phone
						offerEditForm.createTime = getT(detail.offertime*1000)
						that.offerEditForm = offerEditForm
						that.cartList = that.filterValidCartRows(detail.goodslist)
						that.extraFeeLines = Array.isArray(detail.extra_fees)
							? detail.extra_fees.map(function(row) {
								return normalizeExtraFeeLine(row) || {
									extra_item_id: row.extra_item_id,
									name: row.name,
									qty: extraFeeQty(row),
									unit_price: extraFeeUnitPrice(row) || row.amount,
									amount: row.amount,
									remark: row.remark || '',
								}
							})
							: []
						that.loadExtraItemOptions()
						that.getType(), that.getCustomer(), that.getTotal(), that.loading = !1
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getCustomer(e) {
				let that = this
				that.$fetch('addons/hlm/api.Customer/getCustomerList', {
					page: that.page,
					limit: that.limit,
					search: ''
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.customer = res.data.list
						that.syncCustomerIndex()
						if (that.offerEditForm.customer_id) {
							that.loadCustomerPricing(that.offerEditForm.customer_id)
						}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getType(e) {
				let that = this,
					types = [{
						id: '',
						name: '全部分类'
					}]
				that.$fetch('addons/hlm/api.Goods/getCategory', {
					pid: that.offerEditForm.category
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.types = types.concat(res.data)
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getGood(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getGoodsList', {
					page: that.page,
					limit: that.limit,
					pid: that.offerEditForm.category,
					search: that.search,
					category_id: that.types[that.typeIndex].id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.goodList = res.data.list
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 删除商品
			delGood(index) {
				let that = this
				const row = that.cartList[index]
				if (!row || !row.id) {
					that.cartList.splice(index, 1)
					that.getTotal()
					return
				}
				that.$fetch('addons/hlm/api.Cart/del', {
					cart_id: row.id,
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartList = that.filterValidCartRows(res.data)
						that.getTotal()
					} else {
						that.$message({
							message: res.msg || '删除失败',
							type: 'warning',
							duration: 1500,
							center: !0
						})
					}
				}).catch(function(error) {
					console.log(error)
					that.$message({
						message: '删除失败',
						type: 'error',
						duration: 1500,
						center: !0
					})
				})
			},
			tableRowClassName ({row, rowIndex}) {
			    row.index = rowIndex;
				if (isExtraTableRow(row)) return 'quotation-row--extra'
				const cls = []
				if (this.isClonePendingRow(row)) cls.push('quotation-row--pending')
				if (this.isProductRowEditing(row)) cls.push('quotation-row--editing')
				return cls.join(' ')
			},
			isClonePendingRow(row) {
				if (!row || !row.pending_edit) return false
				return this.isCartSizeInvalid(row) || this.isCartNumInvalid(row)
			},
			isProductRowEditing(row) {
				if (!this.cartStatus || !row) return false
				const cartId = this.cartForm && this.cartForm.cart_id
				if (!cartId) return false
				return String(row.id) === String(cartId)
			},
			// 编辑商品
			editCart(e){
				let that = this;
				that.resumeGoodPicker = !1
				const cartIndex = e && e._cartIndex != null ? e._cartIndex : (typeof e === 'number' ? e : e.index);
				const row = that.cartList[cartIndex];
				if (!row) return;
				that.goodActive = cartIndex;
				that.$fetch('addons/hlm/api.Cart/goodsDetails', {
					cart_id: row.id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartForm = {
							cart_id: "",
							goods_id: "",
							sku_ids: "",
							goods_long: "",
							goods_wide: "",
							goods_high: "",
							goods_thick: "",
							reference_image: "",
							remarks: "",
							goods_num: 1,
							goods_category: "",
							order_number: "",
							goods_size: "",
							parameter_ids: ""
						};
						that.good = res.data,that.skuActive = -1,that.cartStatus = !0;
						for(let key in that.cartForm){
							that.cartForm[key] = that.good.cart_info[key];
						}
						that.cartForm.cart_id = that.good.cart_info.id;
						if (that.cartList[that.goodActive] && that.cartList[that.goodActive].pending_edit) {
							that.normalizePendingCartForm()
						}
						that.good.valuation_tips = that.good.cart_info.valuation_tips;
						that.good.valuation = that.good.cart_info.goods_valuation;
						that.good.is_sku = that.good.cart_info.sku_ids!==""?1:0;
						that.good.singleton = that.good.cart_info.singleton,that.good.goods_areas = that.good.cart_info.goods_areas;
						that.good.discount_price = that.good.cart_info.discount_price != null && that.good.cart_info.discount_price !== ''
							? that.good.cart_info.discount_price
							: that.good.cart_info.singleton;
						that.good.is_sku = that.good.cart_info.sku_ids!==""?1:0;
						that.good.parameterList = normalizeParameterList(
							that.good.parameterList,
							that.good.cart_info.parameter_ids,
						);
						if(that.good.is_sku==1) {
							that.good.skuPrice.forEach((price,indexP)=>{
								price.skuIds = price.goods_sku_ids.split(",");
								if(price.goods_sku_ids==that.good.cart_info.sku_ids) that.good.cart_info.skuIds = price.goods_sku_ids.split(",");
							});
							that.good.skuList.forEach((item,index)=>{
								item.children.forEach((child,idx)=>{
									if(child.id==that.good.cart_info.skuIds[index]) item.activeId = child.id,item.activeIndex = idx;
								});
							});
							that.setStock();
							if (that.autoSelectSingleSku()) that.setStock();
						}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			/** 行展示金额数值（与表格「金额」列一致） */
			lineAmountDisplay(row) {
				if (!row || this.isCartNumPending(row)) return 0
				const exclusive = this.isExclusivePriceRow(row)
				const unit = Number(exclusive ? this.resolveDiscountPrice(row) : row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num) || !(num > 0)) return 0
				return Number(accMul(unit, num).toFixed(2))
			},
			/** 行成交金额：专属价行用专属价（不参与折扣让利）；其余按折扣价 × 数量 */
			lineAmountByDeal(row) {
				if (!row || this.isCartNumPending(row)) return 0
				if (this.isExclusivePriceRow(row)) return this.lineAmountDisplay(row)
				const unit = Number(this.resolveDiscountPrice(row))
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num) || !(num > 0)) return 0
				return Number(accMul(unit, num).toFixed(2))
			},
			// 小计=产品金额列合计+附加费（单价×数量）；折扣让利=产品成交合计−产品小计；合计=小计+折扣让利
			getTotal() {
				let that = this
				let subtotal = 0
				let dealSum = 0
				;(that.cartList || []).forEach(function(item) {
					subtotal = accAdd(subtotal, that.lineAmountDisplay(item))
					dealSum = accAdd(dealSum, that.lineAmountByDeal(item))
				})
				const concession = accSub(dealSum, subtotal)
				const extraSum = Number(sumExtraFeeLines(that.extraFeeLines))
				that.offerEditForm.totalAll = Number(accAdd(subtotal, extraSum)).toFixed(2)
				that.offerEditForm.total_primary = Number(subtotal).toFixed(2)
				that.offerEditForm.concession = Number(concession).toFixed(2)
				that.offerEditForm.preferential = 0
				that.offerEditForm.total = Number(accAdd(accAdd(subtotal, concession), extraSum)).toFixed(2)
				that.cartStatsTick += 1
			},
			// 添加产品
			showGood(e) {
				let that = this
				if (!that.offerEditForm.customer_id) {
					that.$message({
						message: '请先选择客户，折扣率/专属价才会生效',
						type: 'warning',
						duration: 2000,
						center: !0
					})
				}
				that.getGood(), that.goodStatus = !0, that.good = null
			},
			searchGood(e) {
				let that = this
				that.goodList = [],that.getGood()
			},
			changeType(e) {
				let that = this
				that.typeIndex = e,that.goodList = [], that.getGood()
			},
			selectGood(e) {
				let that = this
				that.good = e
			},
			onGoodRowClick(row) {
				if (typeof window !== 'undefined' && window.innerWidth <= 768 && row) {
					this.chooseGood(row)
				}
			},
			closeGoodDialog() {
				this.goodStatus = false
				this.$nextTick(() => {
					if (!this.cartStatus) forceHideQuotationDialogs()
				})
			},
			openCartFromPicker() {
				const mobile = this.isMobile || (typeof document !== 'undefined' && document.documentElement.classList.contains('is-mobile-viewport'))
				if (mobile) {
					this.resumeGoodPicker = !1
					this.cartStatus = !0
					return
				}
				this.resumeGoodPicker = !!this.goodStatus
				this.goodStatus = !1
				this.$nextTick(() => {
					this.cartStatus = !0
				})
			},
			onCartDialogClosed() {
				if (this.resumeGoodPicker) {
					this.resumeGoodPicker = !1
					this.goodStatus = !0
					return
				}
				this.$nextTick(() => {
					if (!this.goodStatus) forceHideQuotationDialogs()
				})
			},
			chooseGood(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getGoodsDetails', {
					goods_id: e.id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartForm = {
							cart_id: "",
							goods_id: "",
							sku_ids: "",
							goods_long: "",
							goods_wide: "",
							goods_high: "",
							goods_thick: "",
							reference_image: "",
							remarks: "",
							goods_num: 1,
							goods_category: "",
							order_number: "",
							goods_size: "",
							parameter_ids: ""
						};
						that.good = res.data,that.skuActive = -1;
						that.cartForm.goods_id = that.good.id,that.cartForm.goods_category = that.offerEditForm.category,that.cartForm.order_number = that.offerEditForm.order_number;
						that.good.parameterList = normalizeParameterList(that.good.parameterList, null);
						if(that.good.is_sku==1) {
							that.initSkuSelection();
						}
						that.openCartFromPicker();
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			addGood(e) {
				let that = this
				if (that.good) {
					that.$fetch('addons/hlm/api.Goods/getGoodsDetails', {
						goods_id: that.good.id
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.cartForm = {
								cart_id: "",
								goods_id: "",
								sku_ids: "",
								goods_long: "",
								goods_wide: "",
								goods_high: "",
								goods_thick: "",
								reference_image: "",
								remarks: "",
								goods_num: 1,
								goods_category: "",
								order_number: "",
								goods_size: "",
								parameter_ids: ""
							};
							that.good = res.data,that.skuActive = -1;
							that.cartForm.goods_id = that.good.id,that.cartForm.goods_category = that.offerEditForm.category,that.cartForm.order_number = that.offerEditForm.order_number;
							that.good.parameterList = normalizeParameterList(that.good.parameterList, null);
							if(that.good.is_sku==1) {
								that.initSkuSelection();
							}
							that.openCartFromPicker();
						}
					}).catch(function(error) {
						console.log(error)
					})
				} else {
					that.$message({
						message: '请选择需要添加的产品',
						center: !0,
						type: 'warning',
						duration: 1500
					})
				}
			},
			/** 初始化规格选择：仅 1 项可选时默认选中 */
			initSkuSelection() {
				this.good.skuList.forEach((item) => {
					item.activeId = '';
					item.activeIndex = -1;
				});
				this.good.skuPrice.forEach((price) => {
					price.skuIds = String(price.goods_sku_ids || '').split(',');
				});
				this.setStock();
				if (this.autoSelectSingleSku()) this.setStock();
			},
			/** 规格维度仅 1 项可选时默认选中（未选中的维度） */
			autoSelectSingleSku() {
				const list = this.good && this.good.skuList;
				if (!list || !list.length) return false;
				let changed = false;
				list.forEach((item) => {
					if (item.activeId) return;
					const children = item.children || [];
					const selectable = [];
					children.forEach((child, idx) => {
						if (!child.noStock) selectable.push({ child, idx });
					});
					if (children.length === 1) {
						item.activeIndex = 0;
						item.activeId = children[0].id;
						changed = true;
					} else if (selectable.length === 1) {
						item.activeIndex = selectable[0].idx;
						item.activeId = selectable[0].child.id;
						changed = true;
					}
				});
				return changed;
			},
			isNestedParam,
			leafOptionsForMid,
			selectMidParam(index) {
				const item = onMidParameterChange(this.good.parameterList[index], this.good.parameterList[index].activeMidId);
				this.$set(this.good.parameterList, index, { ...item });
				this.priceInit();
				this.autoCalPrice();
			},
			// 选择参数
			selectParam(val,index){
				let that = this;
				const param = that.good.parameterList[index];
				if (isNestedParam(param)) {
					onLeafParameterChange(param, val);
				} else {
					flatLeafParameterChange(param, val);
				}
				that.$set(that.good.parameterList, index, { ...param });
				that.priceInit();
				that.autoCalPrice();
			},
			// 选择规格
			selectSpec(idx,index){
				let that = this;
				if(that.good.skuList[index].children[idx].noStock) return;
				that.good.skuList = that.good.skuList.map((sku,indexS)=>{
					if(indexS===index) {
						if(sku.activeIndex === idx) {
							sku.activeIndex = -1,sku.activeId = "";
						}else{
							sku.activeIndex = idx,sku.activeId = sku.children[idx].id;
						}
					}
					return sku;
				});
				that.priceInit(),that.setStock();
				that.autoCalPrice();
			},
			// 设置规格状态
			setStock(){
				let that = this,isActive = !0;
				that.specIds = [];
				that.good.skuList.forEach((item,index)=>{
					that.specIds.push(item.activeId);
				});
				let specIds = that.specIds.join(",");
				that.good.skuPrice.forEach((price,indexP)=>{
					if(specIds===price.goods_sku_ids) that.skuActive = indexP,isActive = !1;
				});
				if(isActive) that.skuActive = -1;
				syncSwitchParameterVisibility(that, that.good, that.skuActive);
				that.good.skuList.forEach((item,index)=>{
					item.children.forEach((child,idx)=>{
						let ids = that.specIds.map((specId)=>{
							return specId
						}),num = 0;
						ids[index] = child.id;
						that.good.skuPrice.forEach((price,indexP)=>{
							let skuIds = ids.map((spec,indexS)=>{
								if(spec==="") spec = price.skuIds[indexS];
								return spec;
							});
							let skuIdText = skuIds.join(",");
							if(skuIdText===price.goods_sku_ids&&price.status=="up") num++;
						});
						if(num===0) {
							child.noStock = 1;
						}else{
							child.noStock = 0;
						}
					});
				});
			},
			priceInit(){
				let that = this;
				that.$set(that.good,"goods_areas",""),that.$set(that.good,"singleton",""),that.$set(that.good,"discount_price","");
			},
			shouldShowParameterItem(item) {
				return isParameterItemVisible(item, this.good, this.skuActive)
			},
			/** 报价算价/加购时带上客户 id，后端按专属价优先、否则乘折扣率 */
			attachCustomerId(params){
				const id = this.offerEditForm && this.offerEditForm.customer_id
				if (id) params.customer_id = id
				else params.customer_id = ''
				return params
			},
			// 自动测算 - 检查条件后自动调用测算
			autoCalPrice(){
				let that = this;
				if(!that.good) return;
				if(that.good.is_sku==1){
					let specNum = 0;
					that.good.skuList.forEach((item,index)=>{
						if(item.activeId!==""){
							specNum++;
						}
					});
					if(specNum!==that.good.skuList.length){
						return;
					}
				}
				let needLong = that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13;
				let needHigh = that.good.valuation==6||that.good.valuation==7||that.good.valuation==9;
				let needWide = that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13;
				let needThick = that.good.valuation==9;
				if(needLong && (!that.cartForm.goods_long || that.cartForm.goods_long==="")) return;
				if(needHigh && (!that.cartForm.goods_high || that.cartForm.goods_high==="")) return;
				if(needWide && (!that.cartForm.goods_wide || that.cartForm.goods_wide==="")) return;
				if(needThick && (!that.cartForm.goods_thick || that.cartForm.goods_thick==="")) return;
				that.calPrice();
			},
			// 测算
			calPrice(showMessage){
				let that = this
				let params = that.cartForm,specNum = 0,paramNum = 0;
				if(that.good.is_sku==1){
					that.good.skuList.forEach((item,index)=>{
						if(item.activeId!==""){
							specNum++;
						}
					});
				}
				if(that.good.is_sku==1&&specNum!==that.good.skuList.length){
					that.$message({
						message: `请选择${that.good.skuList[specNum].name}`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if(that.good.is_sku==1) {
					let sku_ids = that.good.skuList.map((item,index)=>{
						return item.activeId;
					});
					let sku_idText = sku_ids.join(",");
					that.good.skuPrice.forEach((item,index)=>{
						if(item.goods_sku_ids===sku_idText) params.sku_ids = item.id;
					});
				};
				let parameter_ids = collectParameterIds(that.good.parameterList, that.good, that.skuActive);
				params.parameter_ids = parameter_ids;
				if((that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_long===""){
					that.$message({
						message: `请输入产品长度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if((that.good.valuation==6||that.good.valuation==7||that.good.valuation==9)&&that.cartForm.goods_high===""){
					that.$message({
						message: `请输入产品高度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if((that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_wide===""){
					that.$message({
						message: `请输入产品宽度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if(that.good.valuation==9&&that.cartForm.goods_thick===""){
					that.$message({
						message: `请输入产品厚度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				that.$post('addons/hlm/api.Cart/getPirec', that.attachCustomerId(params)).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.$set(that.good,"goods_areas",res.data.goods_areas),that.$set(that.good,"singleton",res.data.singleton),that.$set(that.good,"discount_price",res.data.discount_price != null ? res.data.discount_price : res.data.singleton),that.$forceUpdate();
						if (showMessage) {
							that.$message({
								message: '测算成功',
								type: 'success',
								duration: 1500,
								center: !0,
							});
						}
						console.log(that.good)
					} else {
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			submitCart(cartForm) {
				let that = this
				if(that.cartSubmit) return;
				const formRef = that.cartFormRef() || that.$refs[cartForm]
				if (!formRef) return
				formRef.validate((valid) => {
					if (valid) {
						let params = that.cartForm,sku_ids = [];
						if(that.good.is_sku==1){
							that.good.skuList.forEach((item,index)=>{
								if(item.activeId!==""){
									sku_ids.push(item.activeId);
								}else{
									that.$message({
										message: `请选择${item.name}`,
										type: 'warning',
										duration: 1500,
										center: !0
									});
									throw new Error("emptySku");
								}
							});
							if(sku_ids.length<that.good.skuList.length) return;
							let sku_idText = sku_ids.join(",");
							that.good.skuPrice.forEach((item,index)=>{
								if(item.goods_sku_ids===sku_idText) params.sku_ids = item.id;
							});
						}
						params.parameter_ids = collectParameterIds(that.good.parameterList, that.good, that.skuActive);
						if((that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_long===""){
							that.$message({
								message: `请输入产品长度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if((that.good.valuation==6||that.good.valuation==7||that.good.valuation==9)&&that.cartForm.goods_high===""){
							that.$message({
								message: `请输入产品高度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if((that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_wide===""){
							that.$message({
								message: `请输入产品宽度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if(that.good.valuation==9&&that.cartForm.goods_thick===""){
							that.$message({
								message: `请输入产品厚度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if (that.isCartNumInvalid(that.cartForm)) {
							that.$message({
								message: '请输入数量',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						that.cartSubmit = !0;
						const editedCartId = that.cartForm.cart_id
						const pendingMap = {}
						that.cartList.forEach(function(row) {
							if (row && row.id && row.pending_edit) pendingMap[row.id] = !0
						})
						that.$post('addons/hlm/api.Cart/changeCart', that.attachCustomerId(params)).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.cartList = that.filterValidCartRows(res.data).map(function(row) {
									if (String(row.id) === String(editedCartId)) {
										row.pending_edit = that.isCartFormPendingInvalid()
									} else if (pendingMap[row.id]) {
										row.pending_edit = !0
									}
									return row
								})
								that.cartStatus = !1,that.goodStatus = !1,that.good = null,that.specIds = [],that.getTotal(),that.cartSubmit = !1;
								that.$message({
									message: that.cartForm.cart_id===""?'添加成功':"修改成功",
									type: 'success',
									duration: 1000,
									center: !0,
									onClose() {
										
									}
								});
							} else {
								that.cartSubmit = !1;
							}
						}).catch(function(error) {
							console.log(error)
							that.cartSubmit = !1;
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			submitForm(offerEditForm) {
				let that = this
				if (that.quotationStatus) return
				that.validateCustomerInfo(function(customerValid) {
					if (!customerValid) {
						that.$message({
							message: '请完善客户信息',
							type: 'warning',
							duration: 1500,
							center: !0
						})
						that.openCustomerInfoDialog()
						return
					}
					that.$refs[offerEditForm].validate((valid) => {
						if (!valid) {
							that.$message({
								message: '请选择货物运输和发票类型',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						let params = that.offerEditForm
						if (!(Number(params.total) > 0)) {
							that.$message({
								message: '请添加产品',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						if (that.hasPendingCloneItems()) {
							that.$message({
								message: '存在未编辑的克隆产品（尺寸或数量为「-」），请先编辑核对后再确认单据',
								type: 'warning',
								duration: 2500,
								center: !0
							})
							return
						}
						const orderNumber = String(that.offerEditForm.order_number || '')
						const categoryId = Number(that.offerEditForm.category) || 0
						const validCart = that.cartList.filter(function(item) {
							return item && item.id
								&& String(item.order_number || '') === orderNumber
								&& (!categoryId || Number(item.goods_category) === categoryId)
						})
						if (validCart.length === 0) {
							that.$message({
								message: '请添加产品',
								type: 'warning',
								duration: 1500,
								center: !0
							})
							return
						}
						if (validCart.length !== that.cartList.length) {
							that.cartList = validCart
							that.getTotal()
							that.$message({
								message: '已移除无效或过期的商品，请核对后再提交',
								type: 'warning',
								duration: 2500,
								center: !0
							})
							return
						}
						that.quotationStatus = !0
						params.offertime = getTimestamp(params.createTime)
						let transient_ids = validCart.map(function(item) {
							return item.id
						})
						params.transient_ids = transient_ids.join(",");
						params.extra_fees = serializeExtraFees(that.extraFeeLines)
						that.$post('addons/hlm/api.Order/orderUpdate', params).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.$message({
									message: '编辑成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.goBack(),that.quotationStatus = !1;
									}
								});
							} else {
								that.quotationStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.quotationStatus = !1
						})
					})
				})
			},
			cloneCart(index) {
				let that = this
				const row = that.cartList[index]
				if (!row || !row.id) return
				that.$fetch('addons/hlm/api.Cart/goodsDetails', {
					cart_id: row.id
				}).then(function(res) {
					if (res.code != 1) return
					const info = res.data.cart_info
					let params = {
						cart_id: '',
						goods_id: info.goods_id,
						sku_ids: '',
						goods_long: '',
						goods_wide: '',
						goods_high: '',
						goods_thick: '',
						reference_image: info.reference_image || '',
						remarks: info.remarks || '',
						goods_num: 0,
						goods_category: that.offerEditForm.category,
						order_number: that.offerEditForm.order_number,
						goods_size: '',
						parameter_ids: info.parameter_ids || ''
					}
					if (info.sku_ids && res.data.skuPrice) {
						res.data.skuPrice.forEach(function(item) {
							if (item.goods_sku_ids === info.sku_ids) params.sku_ids = item.id
						})
					}
					const oldIds = that.cartList.map(function(item) { return item.id })
					that.$post('addons/hlm/api.Cart/changeCart', that.attachCustomerId(params)).then(function(res2) {
						if (res2.code == 1) {
							const list = that.filterValidCartRows(res2.data)
							const cloned = list.find(function(item) {
								return oldIds.indexOf(item.id) < 0
							})
							if (cloned) {
								cloned.pending_edit = !0
								const rest = list.filter(function(item) { return item.id !== cloned.id })
								rest.splice(index + 1, 0, cloned)
								that.cartList = rest
							} else {
								that.cartList = list
							}
							that.getTotal()
							that.$message({
								message: '克隆成功，请编辑核对尺寸与数量',
								type: 'warning',
								duration: 2500,
								center: !0
							})
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 上下移动
			upLayer(index, row) {
				var that = this;
				if (index == 0) {
					that.$message({
						message: "处于顶端，不能继续上移",
						center: !0,
						type: "warning"
					});
				} else {
					let upDate = that.cartList[index - 1]
					that.cartList.splice(index - 1, 1)
					that.cartList.splice(index, 0, upDate)
				}
			},
			downLayer(index, row) {
				var that = this;
				if (index + 1 === that.cartList.length) {
					that.$message({
						message: "处于末端端，不能继续下移",
						center: !0,
						type: "warning"
					});
				} else {
					let downDate = that.cartList[index + 1]
					that.cartList.splice(index + 1, 1)
					that.cartList.splice(index, 0, downDate)
				}
			},
			sizeSpan({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 4) {
					// if (columnIndex === 0) {
					// 	return [1, 2];
					// } else if (columnIndex === 1) {
					// 	return [0, 0];
					// }
				}
			},
			printQuotation() {
				let that = this
			},
			printInvoice() {
				let that = this
			},
			goBack(){
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/offerEdit.css'>
	/* px2rem能正常转换 */
</style>
<style src='../assets/css/quotation-mobile.css'></style>
